import React from "react";

/**
 * Labelled text input. Pass `error` for the field-level error message.
 * @param {Object} props
 * @param {string} [props.label]
 * @param {string} [props.error]
 * @param {boolean} [props.hasError]
 */
export function Input({ label, error, hasError = false, id, className = "", ...rest }) {
  const cls = ["ds-input", hasError && "is-error", className].filter(Boolean).join(" ");
  return (
    <div className="ds-field">
      {label && <label className="ds-field-label" htmlFor={id}>{label}</label>}
      <input id={id} className={cls} {...rest} />
      {error && <span className="ds-field-error">{error}</span>}
    </div>
  );
}
